<ng-container>
    <app-price-analysis-property
    *ngIf="landPriceGraphData"
    [dropdownLabel]="'reports.pleaseSelectZoning'"
    [SectionId]="chartId"
    [graphData]="landPriceGraphData"
    [chartTitle]="title"
    [reportType]="'price'"
    (filterChartdata)="dropdownChange($event)"
    [chartLoader]="projLandPriceAnalysisLoading"
    ></app-price-analysis-property>
</ng-container>